<script setup lang="ts">
import type { CardPriceControl } from "../cardPrice";

defineProps<{ control: CardPriceControl }>();
</script>

<template>
	<span v-bind="control.prefixAttrs">{{ control.prefix }}</span>
	<span v-bind="control.valueAttrs">{{ control.price }}</span>
</template>
